<section class="shop-section">
  <div class="shop-section-header">
    <h2><i class="fas" [ngClass]="icon" aria-hidden="true"></i> {{ title }}</h2>
    <a *ngIf="viewAllLink" [routerLink]="viewAllLink" class="view-all">See all <i class="fas fa-arrow-right" aria-hidden="true"></i></a>
  </div>

  <div class="shop-scroll-container" *ngIf="loading || shops.length > 0">
    <button type="button" class="scroll-arrow left" (click)="scroll('left')" aria-label="Scroll left">
      <i class="fas fa-chevron-left"></i>
    </button>

    <div class="shop-scroll-row" #scrollRow>
      <ng-container *ngIf="!loading; else loadingState">
        <app-shop-card *ngFor="let shop of shops; trackBy: trackById" [shop]="shop" (quickView)="quickView.emit($event)">
        </app-shop-card>
      </ng-container>

      <ng-template #loadingState>
        <app-shop-card-skeleton *ngFor="let s of skeletons"></app-shop-card-skeleton>
      </ng-template>
    </div>

    <button type="button" class="scroll-arrow right" (click)="scroll('right')" aria-label="Scroll right">
      <i class="fas fa-chevron-right"></i>
    </button>
  </div>

  <ng-content select="[empty]" *ngIf="!loading && shops.length === 0"></ng-content>
</section>
